import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";
const API_URL = `${URL}/api`;

export const fetchSubdivisions = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/subdivisions`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSubdivisionById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/subdivisions/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createSubdivision = async (subdivisionData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/subdivisions`,
      subdivisionData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSubdivision = async ({ id, subdivisionData }) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/subdivisions/${id}`,
      subdivisionData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSubdivision = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/subdivisions/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSubdivisionsByHomeType = async (homeType) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/subdivisions/home-type/${homeType}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchSubdivisionCounts = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/subdivisions/counts`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
